import { I as Icon, _ as __assign } from './loadable.esm-8884282c.js';
import React from 'react';
import 'styled-components';

var StarOutlineIcon = function (props) { return (React.createElement(Icon, __assign({}, props, { viewBox: "0 0 20 20" }),
    React.createElement("path", { d: "M16 8a.46.46 0 00-.47-.31h-3.79l-1.17-3.61a.45.45 0 00-.87 0l-1.18 3.6H4.74a.45.45 0 00-.27.83l3.06 2.23-1.17 3.6a.46.46 0 00.15.54.43.43 0 00.25.08.52.52 0 00.31-.11l3.06-2.23 3.06 2.22a.45.45 0 00.71-.51l-1.17-3.6 3.07-2.21A.46.46 0 0016 8z", fill: "none", stroke: props.color || "currentColor", strokeWidth: "0.5" }))); };

export { StarOutlineIcon as default };
